// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";
import { locales } from "moment";

const local = PRODUCTION === "false" && UAT === "false";
const LOCAL_PORT = "7005";

export const CUSTOMER_APIs = {
  manageCrmApprove: async (args = {}, accessToken = "") => {
    let apiUrl = "/cu/v1/4WB3VEDJEF4D6UR2";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local,
      accessToken
    );
    return response;
  },

  manageCrmAgreement: async (args = {}, accessToken = "") => {
    let apiUrl = "/cu/v1/YJUFXW4111FEJ7HG";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local,
      accessToken
    );
    return response;
  },

  getScavengings: async (args = {}) => {
    let apiUrl = "/cu/v1/NMQQXK4G1WCCBS7I";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  drawOuterMost: async (args = {}) => {
    let apiUrl = "/ai/v1/1QO48H38ZLBI7OI0";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  transferCustomers: async (args = {}) => {
    let apiUrl = "/cu/v1/YMCGHQC93P54QRIG";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getAllCustomersOnMap: async (args = {}) => {
    let apiUrl = "/cu/v1/2BOV0OGD1GXFQLVZ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getStockLevels: async (args = {}) => {
    let apiUrl = "/cu/v1/LPA5JWVBGNZ4WD2L";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  manageStockLevel: async (args = {}) => {
    let apiUrl = "/cu/v1/1VQYIF0D5MZFM07G";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCustSalesTypes: async (args = {}) => {
    let apiUrl = "/cu/v1/8W8JDX0YOUSXO2MC";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  manageCustSalesType: async (args = {}) => {
    let apiUrl = "/cu/v1/DNN10S65USCY76RC";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmApprovals: async (args = {}) => {
    let apiUrl = "/cu/v1/48GR8BYQUY4SOU02";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCrmApproval: async (args = {}) => {
    let apiUrl = "/cu/v1/Q9VSYVMXTX7UIBJ1";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmDocuments: async (args = {}) => {
    let apiUrl = "/cu/v1/R4W8OQMOLYH02ACT";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  manageCrmDocument: async (args = {}) => {
    let apiUrl = "/cu/v1/OH3YJRLEQG4GRNHA";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getFeedbacks: async (args = {}) => {
    let apiUrl = "/cu/v1/WPESLNMBE8YJILXN";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  manageFeedback: async (args = {}) => {
    let apiUrl = "/cu/v1/6SL9U5KUWWZENBMY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmLeadAssigned: async (args = {}) => {
    let apiUrl = "/cu/v1/WGFY2L2O2IOFE382";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageLeadAssigned: async (args = {}) => {
    let apiUrl = "/cu/v1/43XNE0WGZ4QUZUVV";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmLeadProfiles: async (args = {}) => {
    let apiUrl = "/cu/v1/054XKXP835731FWM";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getCustomerOnMap: async (args = {}) => {
    let apiUrl = "/cu/v1/438Z5618L74978RF";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  removeCustomerPhoto: async (args = {}) => {
    let apiUrl = "/cu/v1/458S9085E53540GY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCustomerPhotos: async (args = {}) => {
    let apiUrl = "/cu/v1/991M9250J22211EP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // To create/update customer
  manageCustomerProfile: async (args = {}) => {
    let apiUrl = "/cu/v1/709S5073F13336FB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // To get all customer details
  getCustomerProfiles: async (args = {}) => {
    let apiUrl = "/cu/v1/668D6510V91105XT";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // To get all customer details
  getChallanCustomers: async (args = {}) => {
    let apiUrl = "/cu/v1/792C1465K91718NQ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // To create/update Branch
  manageBranchProfile: async (args = {}) => {
    let apiUrl = "/v1/customer/branchprofile";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // Get customer Branches
  getBranchProfile: async (args = {}) => {
    let apiUrl = "/v1/customer/branchprofiles";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // To create/update customer
  manageCustomerType: async (args = {}) => {
    let apiUrl = "/cu/v1/513C4053D83312PC";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // Get customer Types
  getCustomerTypes: async (args = {}) => {
    let apiUrl = "/cu/v1/710T6972L66442XF";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // To create/update customer address
  manageCustomerAddresses: async (args = {}) => {
    let apiUrl = "/cu/v1/410Y2778T60362OG";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // Get customer address
  getCustomerAddresses: async (args = {}) => {
    let apiUrl = "/cu/v1/424W1574I97636OW";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  //Get Instructions
  getInstructions: async (args = {}) => {
    let apiUrl = "/cu/v1/PHXPT6KQDQS4Z9AH";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  //To Create /Update Instructions
  manageInstruction: async (args = {}) => {
    let apiUrl = "/cu/v1/PQC7LLT43DAHR17U";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  //To Create /Update Customer BusinessType
  manageCustBusinessType: async (args = {}) => {
    let apiUrl = "/cu/v1/XIVEWM78NYAJ1RCW";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCustBusinessTypes: async (args = {}) => {
    let apiUrl = "/cu/v1/C4OAT72681EC1FHB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCrmInterview: async (args = {}) => {
    let apiUrl = "/cu/v1/HFGG6VJ3CR13A0MY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmInterviews: async (args = {}) => {
    let apiUrl = "/cu/v1/NU9JLVMKVUYKKBK8";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageScavenging: async (args = {}) => {
    let apiUrl = "/cu/v1/7XPWB9X12KKGFF6K";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  manageScavengings: async (args = {}) => {
    let apiUrl = "/cu/v1/NID4BA15Q4N136G6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  manageSurvey: async (args = {}) => {
    let apiUrl = "/cu/v1/IX9V47I2EWJ95H7L";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getSurveys: async (args = {}) => {
    let apiUrl = "/cu/v1/KURZR3Y4SSY4TS0K";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getCrmLeadActivities: async (args = {}) => {
    let apiUrl = "/cu/v1/ITDRKDUBEP9XI4DR";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getCustomerDetailsOnMap: async (args = {}) => {
    let apiUrl = "/cu/v1/991M9250J22211EP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
};
